import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './UsersTable.Module.css';

const UsersTable = ({ users, onUserClick }) => {
  const [selected, setSelected] = useState(null);
  const uri = process.env.REACT_APP_BACK_URL;

  const handleUserClick = (user) => {
    setSelected(user);
    onUserClick(user);
  };

  const exportToExcel = async () => {
    try {
      const { data } = await axios.get(`${uri}/api/usuarios/telefonos/ok`);

      // Creamos los datos del Excel
      const excelData = data.usuarios?.map((user) => ({
        Nombre: user.nombre,
        Apellido: user.apellido,
        Teléfono: user.telefono,
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Teléfonos');

      XLSX.writeFile(workbook, 'telefonos_usuarios.xlsx');
    } catch (error) {
      console.error('Error al exportar los teléfonos:', error);
      alert('Hubo un error al exportar los teléfonos.');
    }
  };

  // ✅ Función para formatear el DNI solo si tiene 8 dígitos
  const formatDNI = (dni) => {
    if (!dni) return '';
    const dniStr = dni.toString().replace(/\D/g, ''); // eliminamos cualquier caracter no numérico
    if (/^\d{8}$/.test(dniStr)) {
      return dniStr.replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2.$3');
    }
    return dniStr; // si no tiene 8 dígitos, se muestra tal cual
  };

  return (
    <>
      <div className="d-flex justify-content-end mb-2">
        <Button style={{ marginRight: '2vw' }} variant="success" onClick={exportToExcel}>
          📤 Exportar teléfonos
        </Button>
      </div>

      <Table
        responsive="sm"
        striped
        bordered
        hover
        style={{
          tableLayout: 'fixed',
          width: '100%',
        }}
      >
        {/* Definimos proporciones */}
        <colgroup>
          <col style={{ width: '15%' }} /> {/* Nombre */}
          <col style={{ width: '15%' }} /> {/* Apellido */}
          <col style={{ width: '60%' }} /> {/* Notas */}
          <col style={{ width: '10%' }} /> {/* DNI */}
        </colgroup>

        <thead>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>Notas</th>
            <th>DNI</th>
          </tr>
        </thead>

        <tbody>
          {users?.map((user) => (
            <tr key={user._id} onClick={() => handleUserClick(user)}>
              <td className={selected?._id === user._id ? 'selected' : ''}>
                {user?.nombre?.toUpperCase()}
              </td>
              <td className={selected?._id === user._id ? 'selected' : ''}>
                {user?.apellido?.toUpperCase()}
              </td>
              <td
                className={selected?._id === user._id ? 'selected' : ''}
                title={user?.notas || ''} // tooltip con el texto completo
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {user?.notas || ''}
              </td>
              <td className={selected?._id === user._id ? 'selected' : ''}>
                {formatDNI(user?.dni)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* CSS para cortar texto largo en celdas */}
      <style>
        {`
          td {
            vertical-align: middle;
          }
          td.selected {
            background: #f8d7da; /* mismo efecto que tenías */
          }
        `}
      </style>
    </>
  );
};

export default UsersTable;
